export default {
  apiKey: 'AIzaSyDF_U1rsnWuKU3MIXo9BtHRnz_qqMtbe88',
  authDomain: 'showman-6e8fb.firebaseapp.com',
  databaseURL: 'https://showman-6e8fb.firebaseio.com',
  projectId: 'showman-6e8fb',
  storageBucket: 'showman-6e8fb.appspot.com',
  messagingSenderId: '267590986320'
}
